module.exports = __webpack_public_path__ + "static/media/1005001BE.01e65136.jpg";